<template>
  <transition name="fade">
    <button
      v-show="visible"
      class="go-to-top"
      title="Go to top"
      aria-label="Go to top"
      @click="scrollToTop"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 19V5" />
        <path d="M5 12l7-7 7 7" />
      </svg>
    </button>
  </transition>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  visible: Boolean
});

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
</script>

<style scoped>
.go-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 48px;
  height: 48px;
  z-index: 50;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: rgba(20, 20, 20, 0.9);
  border: 2px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.5);
  transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.go-to-top:hover {
  transform: translateY(-2px) scale(1.05);
  background-color: rgba(34, 34, 34, 0.95);
  border-color: rgba(255, 255, 255, 0.35);
}

.go-to-top svg {
  width: 22px;
  height: 22px;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  transform: scale(0);
}
</style>
